import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const ServiceCard = ({ service }) => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const item = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 150 },
  };
  return (
    <motion.div
      variants={item}
      transition={{ duration: 0.5 }}
      className="col-lg-2 col-md-3 col-sm-4 col-xs-6 service-card-wrapper mb-4"
    >
      <Link to={`${service["url"]}`} className="service-card">
        <img
          src={process.env.REACT_APP_API_URL + service["image"]}
          alt="Service"
        />
        <h5>
          {lang === "en"
            ? service.name_en
            : lang === "ru"
            ? service.name_ru
            : service.name_tm}
        </h5>
        {/* <p>{service["short_content_tm"]}</p> */}
      </Link>
    </motion.div>
  );
};

export default ServiceCard;
